module.exports = __webpack_public_path__ + "media/images/country_flags/bb-1ddcd92a795b283e384fa73ac5022dce.png";